import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ModalContext } from '@taxdown/piccolo-web';
import { emailSelector } from 'Store/modules/auth/selectors';
import GoogleModal from 'Components/UI/GoogleModal';
import { routes } from 'Constants/routes';
import { isGoogleDomain } from 'Utils/validFields';
import View from './view';

const SignUpStepTwo = (): JSX.Element => {
  const { showModal } = useContext(ModalContext);
  const email = useSelector(emailSelector);

  useEffect(() => {
    if (isGoogleDomain(email)) {
      showModal({
        comp: <GoogleModal />,
      });
    }
  }, [email]);

  if (!email) {
    return <Redirect to={routes.SIGNUP} />;
  }

  return <View email={email} />;
};

export default SignUpStepTwo;
